<template>
  <page-section :title="$t('ProfilesPurchases_Title')">
    <rest-list :payload="fetchEndpoint" :loading="!applicationsLoaded">
      <rest-list-column-date
        :sortable="true"
        prop="create_time"
        :title="$t('ProfilesEvents_Field_Timestamp')"
        :width="200"
      />

      <rest-list-column
        prop="properties"
        :title="$t('ProfilesEvents_Field_Title')"
        :sortable="false"
        >purchase
      </rest-list-column>

      <el-table-column :sortable="false" width="200">
        <template slot="header" slot-scope="{}">
          <span>
            {{ $t('ProfilesEvents_Field_Properties') }}
          </span>
          <rest-list-filter-input prop="properties" />
        </template>
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="mini"
            @click="showDataPopup(scope.row.properties)"
          >
            {{ $t('ProfilesEvents_JSON_Button_title') }}
            <el-icon name="view" />
          </el-button>
        </template>
      </el-table-column>

      <rest-list-column-enum
        prop="integration_id"
        :key="integrationsLoaded"
        :title="$t('ProfilesEvents_Field_Integration')"
        :enum="integrations"
        :width="200"
        :sortable="false"
      />

      <rest-list-column-enum
        prop="application_id"
        :key="applicationsLoaded"
        :title="$t('ProfilesEvents_Field_Application')"
        :enum="applications"
        :width="200"
        :sortable="false"
      />

      <rest-list-column
        prop="device_id"
        :title="$t('ProfilesEvents_Field_Device')"
        :route="rowClickDeviceIdRoute"
        :width="200"
        :sortable="false"
      />
    </rest-list>

    <el-dialog
      :title="$t('ProfilesEvents_JSON_Data_Title')"
      :visible="dataPopup"
      :modal="false"
      :modal-append-to-body="false"
      :before-close="closeDataPopup"
    >
      <vue-json-pretty :data="jsonData" class="json-wrapper"></vue-json-pretty>
    </el-dialog>
  </page-section>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import VueJsonPretty from 'vue-json-pretty'
import RestListFilterInput from '@/common/components/rest/RestListFilterInput'
import PageSection from '@/common/components/page/PageSection'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import enquoteBigNumber from '@/common/helpers/JSONBigIntTransfromer'

export default {
  name: 'PurchasesListPage',
  components: {
    PageSection,
    RestListFilterInput,
    RestListColumnDate,
    RestList,
    RestListColumnEnum,
    RestListColumn,
    VueJsonPretty
  },
  data() {
    return {
      dataPopup: false,
      jsonData: null,
      applications: {},
      applicationsLoaded: false,
      integrations: {},
      integrationsLoaded: false
    }
  },
  created() {
    new RestApiPaginator(this.applicationsEndpoint)
      .fetchAllPages()
      .then(data => {
        data.forEach(val => {
          this.applications[val.id] = val.name
        })
        this.applicationsLoaded = true
      })

    new RestApiPaginator(this.integrationsEndpoint)
      .fetchAllPages()
      .then(data => {
        data.forEach(val => {
          this.integrations[val.id] = val.name
        })
        this.integrationsLoaded = true
      })
  },

  methods: {
    showDataPopup(json) {
      this.jsonData = JSON.parse(enquoteBigNumber(json))
      this.dataPopup = true
    },
    closeDataPopup() {
      this.dataPopup = false
    },
    rowClickDeviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: row.device_id
        }
      })
    }
  },
  computed: {
    applicationsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'applications',
        params: {}
      })
    },

    integrationsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'integrations',
        params: {}
      })
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `event-purchase-hits`,
        params: {
          profile_id: this.$route.query.profile_id
        }
      })
    }
  }
}
</script>

<style scoped>
.json-wrapper {
  overflow-y: auto;
  max-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/pages/PurchasesListPage.vue